import React from "react";

import { GetDateTime } from "../lib/DateTimeParse";

export default ({messages, toggle}) => {
    if(toggle || !messages || !messages.count || messages.count < 1){
        return  null
    }
    
    return (
        <div className="dialog-content">
            {
                messages.results && messages.results.map((item, index) =>
                    <div className="msg" key={index}>
                        <div className="top">
                            <strong className="user">{`${item.user.first_name} ${item.user.last_name}`}</strong>
                            <span className="data">{GetDateTime(item.created_at, "DATE")} в {GetDateTime(item.created_at, "TIME")}</span>
                        </div>
                        <div className="msg-content">
                            {item.content}
                        </div>
                    </div>
                )
            }
        </div>
    )
}


// WEBPACK FOOTER //
// ./src/components/MakeOrder/Chat/ChatContent.js